import styled from 'styled-components'
import { OrangeColor, GrayDark } from '../../constants/constants'
import { Calendar2Date } from '@styled-icons/bootstrap/Calendar2Date'

export const VersionSectionWrapper = styled.div`
  objet-fit: fit-content;
`

export const PageTitle = styled.h1`
  color: ${OrangeColor};
  margin: 3rem 0 3rem 0;
  display: flex;
  gap: 6px;
  justify-content: center;
`
export const SubheadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid red;
  padding: 15px;
  margin-top: 2rem;
  margin-bottom: 1rem;
`
export const VersionText = styled.h2`
  margin: 0;
  color: ${GrayDark};
`
export const DateText = styled.span`
  font-size: 1.1rem;
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: 600;
  color: ${GrayDark};
`
export const DateIcon = styled(Calendar2Date)`
  color: ${OrangeColor};
  witdh: 25px;
  height: 25px;
`

export const ListItem = styled.li`
  color: ${OrangeColor};
`
export const ListText = styled.p`
  color: black;
  text-align: justify;
  font-size: 16px;
`
